module.exports = __webpack_public_path__ + "static/media/ic_directorio_pin.61dcc48b.webp";


//////////////////
// WEBPACK FOOTER
// ./assets/img/ic_directorio_pin.webp
// module id = 201
// module chunks = 1